import React, { useState } from 'react';

import { Activity } from '../types';

import AITutorContent from './content/ai_tutor';
import PracticeContent from './content/practice';
import Header from './header';

interface Props {
  activities: Activity[];
  header?: boolean;
  next?: boolean;
}

export default (props: Props) => {
  const unfinishedActivities = props.activities.filter((activity) => (
    activity.status !== 'finished'
  ));

  return (
    <div
      className="bg-white border-radius-all d-flex flex-column gap-m flex-1 u-padding-A-s"
      style={{ border: '1px dashed #B5B1BB' }}
    >
      {
        props.header && (
          <Header activities={props.activities} />
        )
      }

      {
        props.activities.map((activity, idx) => {
          const next = props.hasOwnProperty('next') ? props.next : activity === unfinishedActivities[0];

          if (activity.type === 'ai_tutor') {
            return (
              <div key={idx} className="d-flex flex-column gap-m">
                <AITutorContent activity={activity} next={next} />
                {idx !== props.activities.length - 1 && <hr className="u-margin-A-n" />}
              </div>
            );
          } else if (activity.type === 'practice') {
            return (
              <div key={idx} className="d-flex flex-column gap-m">
                <PracticeContent activity={activity} next={next} />
                {idx !== props.activities.length - 1 && <hr className="u-margin-A-n" />}
              </div>
            );
          }
        })
      }
    </div>
  );
};
